"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMING_ITERATION_3 = exports.KHAnimatedText = exports.AnimState = void 0;
const KHEventHandler_1 = require("./KHEventHandler");
var AnimState;
(function (AnimState) {
    AnimState[AnimState["NotStarted"] = 0] = "NotStarted";
    AnimState[AnimState["Animating"] = 1] = "Animating";
    AnimState[AnimState["DoneAnimating"] = 2] = "DoneAnimating";
})(AnimState || (exports.AnimState = AnimState = {}));
;
class KHAnimatedText extends Phaser.GameObjects.BitmapText {
    constructor(scene, x, y, font, config = { timing: exports.TIMING_ITERATION_3 }) {
        super(scene, x, y, font, "");
        this.animState = AnimState.NotStarted;
        this.config = config;
        this.config.delay = this.config.delay || 100;
        this.scene.add.existing(this);
        this.eventHandler = new KHEventHandler_1.KHEventHandler();
    }
    nextLetter() {
        this.animIdx++;
        if (this.animIdx <= this.fullText.length) {
            const newText = this.fullText.substring(0, this.animIdx);
            this.setText(newText);
            const delay = this.timingFor(this.animIdx);
            if (delay > 0 && this.config.textSound)
                this.config.textSound.play();
            this.addTextCallback(delay);
        }
        else {
            this.doneAnimating();
        }
    }
    timingFor(idx) {
        return this.config.timing(this.charAt(idx - 2), this.charAt(idx - 1), this.charAt(idx), this.config.timing);
    }
    charAt(idx) {
        if (idx < 0 || idx >= this.fullText.length) {
            return '\0';
        }
        return this.fullText.charAt(idx);
    }
    setAnimState(state) {
        this.animState = state;
        this.eventHandler.emitEvent("stateUpdated", { state });
    }
    doneAnimating() {
        if (this.state == AnimState.DoneAnimating)
            return;
        this.setAnimState(AnimState.DoneAnimating);
        this.setText(this.fullText);
        this.animIdx = this.fullText.length;
        if (this.animEvent)
            this.animEvent.remove(false);
    }
    startAnimating() {
        if (this.state == AnimState.Animating)
            return;
        this.setAnimState(AnimState.Animating);
        this.setText("");
        this.animIdx = 0;
        this.addTextCallback(this.timingFor(0));
    }
    addTextCallback(delay) {
        if (delay > 0) {
            this.animEvent = this.scene.time.addEvent({
                delay: delay,
                callback: () => this.nextLetter(),
            });
        }
        else {
            this.nextLetter();
        }
    }
    animateText(text) {
        this.fullText = text;
        if (!this.config.naiveWrap) {
            this.setText(this.fullText);
            const bounds = this.getTextBounds(false);
            this.fullText = bounds.wrappedText || this.fullText;
        }
        this.setText("");
        this.startAnimating();
    }
    isAnimating() {
        return this.animState == AnimState.Animating;
    }
    stopAnimation() {
        if (this.animState != AnimState.Animating)
            return;
        this.doneAnimating();
    }
}
exports.KHAnimatedText = KHAnimatedText;
const TIMING_ITERATION_3 = function (prev, curr, next, timing) {
    // It looks odd to have extra time for a closing brace or quote,
    // so apply the previous time (which was skipped) to play them
    // together.
    switch (curr) {
        case ')':
        case '"':
        case ']':
        case '}':
            return timing('\0', prev, ' ', timing);
    }
    // If the next character is one that we handled above, immediately move on
    // to the next character. This character's delay will get added on at that
    // phase.
    switch (next) {
        case ')':
        case '"':
        case ']':
        case '}':
        case '\0':
            return 0;
    }
    switch (curr) {
        case '\0':
        case ' ':
        case '\n':
            return 0;
        case '.':
            if (prev == '.' || next == '.')
                return 200;
        case '!':
        case '?':
        case ';':
            return 400;
        case ':':
        case '—':
        case ',':
            return 200;
        default:
            return 50;
    }
};
exports.TIMING_ITERATION_3 = TIMING_ITERATION_3;
